function Image({ img, name }) {
	if (!img) return null;

	const uri = img.startsWith('http') ? img : process.env.REACT_APP_IMG + img;

	return <img src={uri} alt={name} id="pr-img" />;
}

export default Image;
